import { useNavigate } from "react-router-dom";
import { BsPencilFill } from "react-icons/bs";
import { useDeleteCategory, useGetCategory } from "../../features/category";
import ModalConfirmationDelete from "../../components/ModalConfirmationDelete";
import { useState } from "react";
import { FiTrash } from "react-icons/fi";

const CategoryPage = () => {
  const { category } = useGetCategory();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { Delete } = useDeleteCategory();

  const [id, setId] = useState("");

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setId("");
  };

  const handleConfirmDelete = () => {
    Delete(id, {
      onSuccess: () => handleCloseModal(),
    });
  };

  return (
    <>
      <div className="p-6">
        <div className="overflow-x-auto">
          <div className="flex justify-between mb-5">
            <h1 className="mt-2 mb-5 font-semibold text-xl text-gray-900">
              Category List
            </h1>
            <button
              type="button"
              onClick={() => navigate("/category/create")}
              className="mt-6 text-xs px-3 py-2 bg-green-500 text-white font-medium rounded-md focus:outline-none focus:ring-2"
            >
              Create
            </button>
          </div>
          <table className="min-w-full bg-white rounded-lg shadow-md">
            <thead className="bg-blue-800 text-white">
              <tr>
                <th className="px-6 py-3 text-left text-sm font-medium">
                  Name
                </th>
                <th className="px-6 py-3 text-left text-sm font-medium">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {category?.map((item, index) => (
                <tr key={index} className="hover:bg-gray-50">
                  <td className="px-6 py-4 text-sm text-gray-700">
                    {item.name}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-700 cursor-pointer flex gap-3 items-center">
                    <BsPencilFill
                      className="text-gray-400 cursor-pointer hover:text-red-600"
                      onClick={() => {
                        navigate(`/category/update/${item.id}`);
                      }}
                    />
                    <div
                      onClick={() => {
                        setIsModalOpen(true);
                        setId(item?.id);
                      }}
                    >
                      <FiTrash />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <ModalConfirmationDelete
        isOpen={isModalOpen}
        title="Apakah Anda yakin akan Delete Transaction"
        onClose={handleCloseModal}
        onConfirm={handleConfirmDelete}
      />
    </>
  );
};

export default CategoryPage;
